import QuantityConversion from './QuantityConversion';
import {
    VerifyNumericLimit_Btw_MinMax,
    VerifyNumericLimit_ByLimit,
    RoundValueASTM,
    RoundValueASTM_ValAsStr,
    Approximates,
    RemoveScientificNotation,
    GetDecimalsFromString,
    VpsCommodity,
    VpsGravityType,
    VpsTemperatureUnit,
    VpsQuantityUnit
} from './FuelMath';
import { MathFormula } from './Math';
import { ParameterType } from './Settings';


export default class QuantityConversionService {
    // constructor() {
    //     super();
    // }

    static response = {
        altValue: "",
        VCF: "",
        WCF: "",
        Mass_MT: ""
    };
    static errors = [];
    static Convert = (config) => {
        
        const conversion = new QuantityConversion();
        conversion.Commodity = config.commodity; // Need to assign commodity fromip
        conversion.ObservedGravityType = config.gravityType; // Need to assign commodity fromip
        conversion.ObservedGravityValue = config.gravityValue;
        conversion.ObservedGravityTemperature = config.gravityTempValue;
        conversion.ObservedGravityTemperatureUnit = config.gravityTempType;
        conversion.ObservedGravityPressure = config.gravityPressValue;
        conversion.ObservedGravityPressureUnit = config.gravityPressType;

        conversion.ObservedQuantityUnit = config.obsQuantType;
        conversion.ObservedQuantityValue = config.obsQuantValue;
        conversion.ObservedQuantityTemperature = config.obsQuantTempValue;
        conversion.ObservedQuantityTemperatureUnit = config.obsQuantTempType;
        conversion.ObservedQuantityPressure = config.obsQuantPressValue;
        conversion.ObservedQuantityPressureUnit = config.obsQuantPressType;

        conversion.AlternateQuantityUnit = config.altType;
        conversion.AlternateQuantityTemperature = config.altTempValue;
        conversion.AlternateQuantityTemperatureUnit = config.altTempType;
        conversion.AlternateQuantityPressure = config.altPressValue;
        conversion.AlternateQuantityPressureUnit = config.altPressType;
        ;
        let check = conversion.ValidateBoundary(0, config.commodity, config.gravityType, config.gravityValue);
        let check1 = conversion.ValidateBoundary(1, config.commodity, config.gravityTempType, config.gravityTempValue);
        let check2 = conversion.ValidateBoundary(2, config.commodity, config.gravityPressType, config.gravityPressValue);
        //let check3 = conversion.ValidateBoundary(0, config.commodity, config.obsQuantType, config.obsQuantTempValue);
        let check4 = conversion.ValidateBoundary(1, config.commodity, config.obsQuantTempType, config.obsQuantTempValue);
        let check5 = conversion.ValidateBoundary(2, config.commodity, config.obsQuantPressType, config.obsQuantPressValue);
        //let check6 = conversion.ValidateBoundary(0, config.commodity, config.altType, config.obsQuantTempValue);
        let check7 = conversion.ValidateBoundary(1, config.commodity, config.altTempType, config.altTempValue);
        let check8 = conversion.ValidateBoundary(2, config.commodity, config.altPressType, config.altPressValue);
        if (!check.Valid) {
            this.errors.push(check.Message);
        }
        if (!check1.Valid) {
            this.errors.push(check1.Message);
        }
        if (!check2.Valid) {
            this.errors.push(check2.Message);
        }
        /* if (!check3.Valid) {
            this.errors.push(check3.Message);
        }
         */if (!check4.Valid) {
            this.errors.push(check4.Message);
        }
        if (!check5.Valid) {
            this.errors.push(check5.Message);
        }
        /* if (!check6.Valid) {
            this.errors.push(check6.Message);
        } */ if (!check7.Valid) {
            this.errors.push(check7.Message);
        } if (!check8.Valid) {
            this.errors.push(check8.Message);
        }
        
        if (!conversion.Exception && check.Valid && check1.Valid && check2.Valid /* && check3.Valid */ && check4.Valid && check5.Valid /* && check6.Valid */ && check7.Valid && check8.Valid) {
            conversion.ConvertQuantity();
            if (!conversion.Exception) {
                switch (config.altType) {
                    case VpsQuantityUnit.CubicMetres:
                        QuantityConversionService.response.altValue = RoundValueASTM_ValAsStr(conversion.CubicMetres, 0.001);
                        break;
                    case VpsQuantityUnit.Barrels:
                        QuantityConversionService.response.altValue = RoundValueASTM_ValAsStr(conversion.Barrels, 0.001);
                        break;
                    case VpsQuantityUnit.USGallons:
                        QuantityConversionService.response.altValue = RoundValueASTM_ValAsStr(conversion.US_Gallons, 0.001);
                        break;
                    case VpsQuantityUnit.MetricTons:
                        QuantityConversionService.response.altValue = RoundValueASTM_ValAsStr(conversion.MetricTons, 0.001);
                    default:
                        break;
                }

                let volumeConFactor = conversion.VolumeConversionFactor;
                QuantityConversionService.response.VCF = volumeConFactor != "" ? MathFormula.roundAccurately((volumeConFactor), 5) : "";
                QuantityConversionService.response.WCF = conversion.ObservedQuantityUnit == 4 && conversion.AlternateQuantityUnit == 4 ? "" : (MathFormula.roundAccurately((conversion.WeightFactor),5));
                QuantityConversionService.response.Mass_MT = conversion.Mass_MT == 0 || conversion.ObservedQuantityUnit == 4 && conversion.AlternateQuantityUnit == 1 || conversion.AlternateQuantityUnit == 2 || conversion.AlternateQuantityUnit == 3 ? "" : conversion.Mass_MT;
                return QuantityConversionService.response;
            }
            else {
                //alert(conversion.ExceptionDescription);
                this.errors.push(conversion.ExceptionDescription);
                return;
            }
        }
    }

}